import { Quote } from "lucide-react";
import PageShell from "../components/PageShell";
import PageHeader from "../components/PageHeader";
import RankBadge from "../components/RankBadge";
import { CARGOS, RANKS_NOTE } from "../data/staffData";

export default function Ranks() {
    return (
        <PageShell testid="page-ranks">
            <PageHeader
                eyebrow="Ranks da Equipe Staff"
                title="Tabela de Ranks"
                description="A organização completa dos Ranks da Staff, do mais alto ao mais baixo nível hierárquico."
            />
            <div
                data-testid="ranks-note"
                className="glass-card mb-6 flex items-start gap-3 rounded-2xl border-l-2 border-l-violet-500 p-5"
            >
                <Quote className="mt-0.5 h-4 w-4 shrink-0 text-violet-400" />
                <p className="text-sm leading-relaxed text-gray-300">{RANKS_NOTE}</p>
            </div>
            <div className="glass-card overflow-hidden rounded-2xl">
                <div className="overflow-x-auto">
                    <table
                        data-testid="ranks-table"
                        className="w-full min-w-[560px] text-left"
                    >
                        <thead>
                            <tr className="border-b border-white/10 font-code text-[10px] font-medium uppercase tracking-[0.22em] text-gray-500">
                                <th className="px-5 py-4">Nº</th>
                                <th className="px-5 py-4">Cargo</th>
                                <th className="px-5 py-4">Categoria</th>
                                <th className="px-5 py-4">Rank</th>
                            </tr>
                        </thead>
                        <tbody>
                            {CARGOS.map((cargo, i) => {
                                const Icon = cargo.icon;
                                return (
                                    <tr
                                        key={cargo.slug}
                                        data-testid={`rank-row-${cargo.slug}`}
                                        className="border-b border-white/5 transition-colors last:border-0 hover:bg-white/[0.03]"
                                    >
                                        <td className="px-5 py-3.5 font-code text-xs text-gray-600">
                                            {String(i + 1).padStart(2, "0")}
                                        </td>
                                        <td className="px-5 py-3.5">
                                            <div className="flex items-center gap-3">
                                                <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-violet-500/20 bg-violet-500/10 text-violet-300">
                                                    <Icon className="h-4 w-4" />
                                                </span>
                                                <span className="text-sm font-semibold text-gray-100">
                                                    {cargo.nome}
                                                </span>
                                            </div>
                                        </td>
                                        <td className="px-5 py-3.5">
                                            <span className="text-xs text-gray-500">
                                                {cargo.categoria}
                                            </span>
                                        </td>
                                        <td className="px-5 py-3.5">
                                            <RankBadge rank={cargo.rank} />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </PageShell>
    );
}
